module.exports = __webpack_public_path__ + "static/media/culinary-art.e0218262.svg";